import { api } from './apiProvider';

export interface InvoiceListItem {
  id: string;
  invoiceDate: Date;
  invoiceNumber: number;
  total: number;
  totalWithSurcharge?: number | null;
  amountDue: number;
  dueDate: Date;
  status: string;
}

export interface InvoicesPaymentCommand extends InvoicesPaymentSummaryRequest {
  paymentMethodType: string;
}

export interface InvoicesPaymentSummaryRequest {
  paymentMethodId: string;
  invoiceIds: string[];
}

export interface InvoicesSurchargeResponse {
  invoiceId: string;
  invoiceTotalWithSurcharge: number;
}

export interface InvoicesPaymentSummaryResponse {
  succeededCount: number;
  failedCount: number;
  inProgressCount: number;
}

export async function listInvoices(): Promise<InvoiceListItem[]> {
  return await api
    .get('invoices', {
      credentials: 'include',
    })
    .json<InvoiceListItem[]>();
}

export async function getInvoicePaymentSummary(request: InvoicesPaymentSummaryRequest): Promise<InvoicesPaymentSummaryResponse> {
  return await api
    .post('invoices/new-payments-summary', {
      credentials: 'include',
      json: request,
    })
    .json<InvoicesPaymentSummaryResponse>();
}

export async function calculateInvoiceSurcharges(invoices: InvoiceListItem[]) {
  const invoiceIds = invoices.map((i) => i.id);
  if (invoiceIds.length) {
    const surcharges = await api
      .post('invoices/calculate-surcharges', {
        credentials: 'include',
        json: { invoiceIds },
      })
      .json<InvoicesSurchargeResponse[]>();

    for (const invoice of invoices) {
      const surcharge = surcharges.find((x) => x.invoiceId === invoice.id);
      if (surcharge) {
        invoice.totalWithSurcharge = surcharge.invoiceTotalWithSurcharge;
      } else {
        invoice.totalWithSurcharge = invoice.amountDue;
      }
    }
  }
  return invoices;
}
